import script from "./GraphLegendItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./GraphLegendItem.vue?vue&type=script&setup=true&lang=ts"

import "./GraphLegendItem.vue?vue&type=style&index=0&id=1f72ad89&lang=css"

const __exports__ = script;

export default __exports__